import {createReducer} from "redux-act";
import {IDictionary} from "modules/types";
import {fetchChecksumsSuccess} from "modules/actions";

export type IChecksumsReducer = IDictionary<string>;

export const checksums = createReducer<IChecksumsReducer>({}, {}).on(
	fetchChecksumsSuccess,
	(_state, checksumsPayload) => checksumsPayload
);
